import * as types from "./types";

const mutations = {
    [types.LOADING_NOTE](state, value) {
        state.loading = value;
    },
    [types.GET_NOTE_LIST](state, note) {
        state.note = note;
    },
    [types.REMOVE_NOTE](state, id) {        
        state.note = state.note.filter((x) => x.id !== id);   
    },
    [types.ADD_NOTE](state, note) {        
        state.note.unshift(note);
    },
    [types.UPDATE_NOTE](state, note) {        
        const NoteIndex = state.note.findIndex((x) => x.id === note.id);
        state.note[NoteIndex] = note;        
    },
    [types.GET_NOTE_BY_ID](state, id) {        
        state.note = state.note.filter((x) => x.id !== id);        
    },
    [types.GET_NOTE_BY_LEADID](state, notebyleadid) {        
        state.notebyleadid = notebyleadid;
    },
};

export default mutations;